export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImFlODFkODcwLTEwMmQtNGY4ZC1hNWExLTJhMTFkNGE4NWQ4OSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.DHLyVpVxx8rVsYAyoHQg26fV46CdQODuq5ctxNO8f20xiSibkDgGw64KoGuonp5erQn45inAG9KgRWQp5yapvbcTCiTSHCgdrIDaPRQ2VWupES8FE3UAKisNX+O6KT8o6MkU8g==";
